const colors = require('tailwindcss/colors');

const grey = colors.slate;

const background = {
  paper   : colors.slate[900],
  default : '#0b0f19',
};

const primary = {
  main         : colors.orange[400],
  light        : colors.orange[300],
  dark         : colors.orange[500],
  contrastText : colors.white,
};

const secondary = {
  main         : colors.sky[500],
  light        : colors.sky[400],
  dark         : colors.sky[600],
  contrastText : colors.white,
};

const success = {
  main         : colors.emerald[500],
  light        : colors.emerald[400],
  dark         : colors.emerald[600],
  contrastText : colors.white,
};

const info = {
  main         : colors.violet[500],
  light        : colors.violet[400],
  dark         : colors.violet[600],
  contrastText : colors.white,
};

const warning = {
  main         : colors.amber[400],
  light        : colors.amber[300],
  dark         : colors.amber[500],
  contrastText : colors.white,
};

const error = {
  main         : colors.red[500],
  light        : colors.red[400],
  dark         : colors.red[600],
  contrastText : colors.white,
};

const text = {
  primary   : colors.white,
  secondary : colors.slate[400],
  disabled  : colors.slate[600],
  icon      : colors.slate[400],
};

const divider = colors.slate[500];

const darkPalette = {
  mode: 'dark',
  grey,
  background,
  primary,
  secondary,
  success,
  info,
  warning,
  error,
  text,
  divider,
}

export default darkPalette;
